import { newspinConstants } from "../constants";
import { newspinService } from "../services";

export const newspinActions = {
    pin,
    getSavedNewsList,
    getPinCounts
};

function pin(pin) {

    return dispatch => {
        dispatch({ type: newspinConstants.NEWSPIN_SAVE_REQUEST });

        newspinService.pin(pin)
            .then(data => dispatch({ type: newspinConstants.NEWSPIN_SAVE_SUCCESS, payload: [data, pin] }))
            .catch(error => dispatch({ type: newspinConstants.NEWSPIN_SAVE_FAILURE, payload: [error, pin] }));
    };
}

function getSavedNewsList(uuid) {

    return dispatch => {
        dispatch({ type: newspinConstants.NEWSPIN_SAVE_REQUEST });

        newspinService.getSavedNewsList(uuid)
            .then(data => dispatch({ type: newspinConstants.NEWSPIN_SAVE_SUCCESS, payload: [data, undefined] }))
            .catch(error => dispatch({ type: newspinConstants.NEWSPIN_SAVE_FAILURE, payload: [error, undefined] }));
    };
}

function getPinCounts() {

    return dispatch => {
        newspinService.getPinCounts()
            .then(data => dispatch({ type: newspinConstants.NEWSPIN_SAVE_SUCCESS, payload: [data, undefined] }))
            .catch(error => dispatch({ type: newspinConstants.NEWSPIN_SAVE_FAILURE, payload: [error, undefined] }));
    };
}
